module.exports = __webpack_public_path__ + "static/media/applenav-tv.95aefa3c.PNG";